import { lazy, Suspense } from 'react';

import { Loading } from '../../components/ui.jsx';

/**
 * Public content (knowledgebase, announcements, downloads, status, contact, custom pages at /p/:slug)
 * and its admin pages. The custom pages' menu links are drawn by the shell (components/SitePages.jsx).
 */
const page = (load, name) => () => load().then((m) => ({ Component: m[name] }));
const pub = () => import('./PublicContent.jsx');
const admin = () => import('./AdminContent.jsx');

const Widget = lazy(() => pub().then((m) => ({ default: m.LatestAnnouncementsWidget })));
function LatestAnnouncementsWidget() {
  return (
    <Suspense fallback={<Loading />}>
      <Widget />
    </Suspense>
  );
}

export default {
  name: 'content',
  publicRoutes: [
    { path: 'knowledgebase', lazy: page(pub, 'Knowledgebase') },
    { path: 'knowledgebase/article/:slug', lazy: page(pub, 'KbArticle') },
    { path: 'knowledgebase/:category', lazy: page(pub, 'KbCategory') },
    { path: 'announcements', lazy: page(pub, 'Announcements') },
    { path: 'announcements/:id', lazy: page(pub, 'Announcement') },
    { path: 'downloads', lazy: page(pub, 'Downloads') },
    { path: 'status', lazy: page(pub, 'NetworkStatus') },
    { path: 'contact', lazy: page(pub, 'Contact') },
    { path: 'accessibility', lazy: page(() => import('./Accessibility.jsx'), 'AccessibilityStatement') },
    { path: 'p/:slug', lazy: page(() => import('./CustomPage.jsx'), 'CustomPage') },
  ],
  adminRoutes: [
    { path: 'content/kb', lazy: page(admin, 'KbAdmin') },
    { path: 'content/kb/:id', lazy: page(admin, 'KbEditor') },
    { path: 'content/announcements', lazy: page(admin, 'AnnouncementsAdmin') },
    { path: 'content/downloads', lazy: page(admin, 'DownloadsAdmin') },
    { path: 'content/status', lazy: page(admin, 'StatusAdmin') },
    { path: 'content/pages', lazy: page(() => import('./PagesAdmin.jsx'), 'PagesAdmin') },
  ],
  clientNav: [
    { key: 'knowledgebase', to: '/knowledgebase', label: 'Help articles', order: 80 },
    { key: 'announcements', to: '/announcements', label: 'Announcements', order: 85 },
    { key: 'network-status', to: '/status', label: 'Network status', order: 88 },
  ],
  adminNav: [
    { section: 'content', to: '/admin/content/kb', label: 'Help articles', permission: 'admin.support.kb', order: 50 },
    {
      section: 'content',
      to: '/admin/content/announcements',
      label: 'Announcements',
      permission: 'admin.support.announcements',
      order: 60,
    },
    {
      section: 'content',
      to: '/admin/content/downloads',
      label: 'Downloads',
      permission: 'admin.support.downloads',
      order: 70,
    },
    {
      section: 'content',
      to: '/admin/content/status',
      label: 'Network status',
      permission: 'admin.support.network_status',
      order: 80,
    },
    { section: 'content', to: '/admin/content/pages', label: 'Pages', permission: 'admin.support.pages', order: 90 },
  ],
  clientWidgets: [{ key: 'latest-announcements', order: 80, Component: LatestAnnouncementsWidget }],
};
